import React from "react";

import { formatCurrency } from "../../../../../../utils";
import { FixedVariantProps } from "./types";
import { LogPaymentButton } from "./LogPaymentButton";
import {
  NextAmount,
  SplitBar,
  SplitPrincipal,
  SplitLegend,
  LegendItem,
  LegendSwatch,
  LegendValue,
  EmptyScheduleText,
  NextFootnote,
} from "./styles";

export const FixedVariant: React.FC<FixedVariantProps> = ({
  hasPaymentAmount,
  paymentAmount,
  principalPortion,
  interestPortion,
  principalPercent,
  onLogPayment,
}) => {
  let amountBlock: React.ReactNode;
  if (hasPaymentAmount) {
    amountBlock = (
      <>
        <NextAmount data-testid="liability-next-amount">
          {formatCurrency(paymentAmount)}
        </NextAmount>
        <SplitBar
          role="img"
          aria-label={`Principal ${formatCurrency(
            principalPortion,
          )}, interest ${formatCurrency(interestPortion)}`}
        >
          <SplitPrincipal $pct={principalPercent} />
        </SplitBar>
        <SplitLegend>
          <LegendItem>
            <LegendSwatch $kind="principal" />
            Principal{" "}
            <LegendValue>{formatCurrency(principalPortion)}</LegendValue>
          </LegendItem>
          <LegendItem>
            <LegendSwatch $kind="interest" />
            Interest{" "}
            <LegendValue>{formatCurrency(interestPortion)}</LegendValue>
          </LegendItem>
        </SplitLegend>
      </>
    );
  } else {
    amountBlock = (
      <EmptyScheduleText>
        Set a payment schedule to project your next installment.
      </EmptyScheduleText>
    );
  }

  return (
    <>
      {amountBlock}
      <LogPaymentButton onLogPayment={onLogPayment} />
      {hasPaymentAmount && (
        <NextFootnote>
          Recalculated from your outstanding balance after each payment
        </NextFootnote>
      )}
    </>
  );
};
